/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feedbacksurveys": {
        "nested": {
          "Responder": {
            "fields": {
              "sellerResponderInfo": {
                "type": "squareup.feedbacksurveys.Responder.SellerResponderInfo",
                "id": 1
              }
            },
            "nested": {
              "SellerResponderInfo": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "employmentToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "responder_info": {
                "oneof": ["sellerResponderInfo"]
              }
            }
          },
          "Survey": {
            "fields": {
              "surveyToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "locale": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "page": {
                "type": "squareup.feedbacksurveys.Survey.SurveyPage",
                "id": 3,
                "rule": "repeated"
              }
            },
            "nested": {
              "SurveyPage": {
                "fields": {
                  "pageNumber": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "surveyQuestion": {
                    "type": "squareup.feedbacksurveys.Survey.SurveyPage.SurveyQuestion",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "SurveyQuestion": {
                    "fields": {
                      "questionToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "questionType": {
                        "type": "squareup.feedbacksurveys.QuestionType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "questionNumber": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": 0
                        }
                      },
                      "questionPrompt": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "questionChoice": {
                        "type": "squareup.feedbacksurveys.Choice",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "localizedQuestionPrompt": {
                        "type": "squareup.feedbacksurveys.Survey.SurveyPage.SurveyQuestion.LocalizedQuestionPrompt",
                        "id": 6,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "LocalizedQuestionPrompt": {
                        "fields": {
                          "locale": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "localizedPrompt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          "Choice": {
            "fields": {
              "value": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "QuestionType": {
            "values": {
              "FREE_FORM": 0,
              "SINGLE_SELECT": 1,
              "MULTIPLE_SELECT": 2,
              "CSAT": 3
            }
          },
          "GetSurveyRequest": {
            "fields": {
              "surveyToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "locale": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "GetSurveyResponse": {
            "fields": {
              "survey": {
                "type": "squareup.feedbacksurveys.Survey",
                "id": 1,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Responder && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Responder?.nested?.SellerResponderInfo && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Survey && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Survey?.nested?.SurveyPage && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Survey?.nested?.SurveyPage?.nested?.SurveyQuestion && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Survey?.nested?.SurveyPage?.nested?.SurveyQuestion?.nested?.LocalizedQuestionPrompt && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.Choice && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.QuestionType && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.GetSurveyRequest && !$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.GetSurveyResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Responder @ squareup/feedbacksurveys/common.proto at 8:1
 */
export const Responder = $root.lookupType('squareup.feedbacksurveys.Responder');
fixType(Responder);
Builder.createAndAttachToType(Responder);
/**
 * SOURCE SellerResponderInfo @ squareup/feedbacksurveys/common.proto at 9:3
 */
Responder.SellerResponderInfo = $root.lookupType('squareup.feedbacksurveys.Responder.SellerResponderInfo');
fixType(Responder.SellerResponderInfo);
Builder.createAndAttachToType(Responder.SellerResponderInfo);
/**
 * SOURCE Survey @ squareup/feedbacksurveys/common.proto at 21:1
 */
export const Survey = $root.lookupType('squareup.feedbacksurveys.Survey');
fixType(Survey);
Builder.createAndAttachToType(Survey);
/**
 * SOURCE SurveyPage @ squareup/feedbacksurveys/common.proto at 22:3
 */
Survey.SurveyPage = $root.lookupType('squareup.feedbacksurveys.Survey.SurveyPage');
fixType(Survey.SurveyPage);
Builder.createAndAttachToType(Survey.SurveyPage);
/**
 * SOURCE SurveyQuestion @ squareup/feedbacksurveys/common.proto at 23:5
 */
Survey.SurveyPage.SurveyQuestion = $root.lookupType('squareup.feedbacksurveys.Survey.SurveyPage.SurveyQuestion');
fixType(Survey.SurveyPage.SurveyQuestion);
Builder.createAndAttachToType(Survey.SurveyPage.SurveyQuestion);
/**
 * SOURCE LocalizedQuestionPrompt @ squareup/feedbacksurveys/common.proto at 45:7
 */
Survey.SurveyPage.SurveyQuestion.LocalizedQuestionPrompt = $root.lookupType('squareup.feedbacksurveys.Survey.SurveyPage.SurveyQuestion.LocalizedQuestionPrompt');
fixType(Survey.SurveyPage.SurveyQuestion.LocalizedQuestionPrompt);
Builder.createAndAttachToType(Survey.SurveyPage.SurveyQuestion.LocalizedQuestionPrompt);
/**
 * SOURCE Choice @ squareup/feedbacksurveys/common.proto at 69:1
 */
export const Choice = $root.lookupType('squareup.feedbacksurveys.Choice');
fixType(Choice);
Builder.createAndAttachToType(Choice);
/**
 * Types of supported survey questions.
 *
 * SOURCE QuestionType @ squareup/feedbacksurveys/common.proto at 84:1
 */
export const QuestionType = $root.lookupEnum('squareup.feedbacksurveys.QuestionType').values;
/**
 * SOURCE GetSurveyRequest @ squareup/feedbacksurveys/common.proto at 101:1
 */
export const GetSurveyRequest = $root.lookupType('squareup.feedbacksurveys.GetSurveyRequest');
fixType(GetSurveyRequest);
Builder.createAndAttachToType(GetSurveyRequest);
/**
 * SOURCE GetSurveyResponse @ squareup/feedbacksurveys/common.proto at 109:1
 */
export const GetSurveyResponse = $root.lookupType('squareup.feedbacksurveys.GetSurveyResponse');
fixType(GetSurveyResponse);
Builder.createAndAttachToType(GetSurveyResponse);